import { CardLink as _CardLink, CardLinkProps as _CardLinkProps } from "reactstrap";

    export const CardLink = _CardLink;
    export type CardLinkProps = _CardLinkProps;
    